import React from "react";
import { motion } from "framer-motion";

const steps = [
    {
        n: "01",
        title: "Discovery Call",
        desc: "We start with a free 30-minute call to understand your business, your goals, your team, and where revenue is leaking. No pitch deck. Just an honest conversation.",
    },
    {
        n: "02",
        title: "Tailored Plan",
        desc: "I build a focused plan around the package or hourly support that fits — with clear deliverables, timelines, and measurable revenue outcomes from day one.",
    },
    {
        n: "03",
        title: "Build & Launch",
        desc: "We handle the heavy lifting — concepting events, writing the copy, training your team, configuring your systems, and pushing campaigns out the door. You stay focused on your guests; we run the playbook for you.",
    },
    {
        n: "04",
        title: "Track & Iterate",
        desc: "Every month we review what worked, what didn't, and where to push next. The goal isn't a pretty deliverable — it's a healthier P&L.",
    },
];

export default function HowItWorks() {
    return (
        <section
            id="process"
            data-testid="process-section"
            className="py-24 md:py-32 bg-brand-cream border-t border-brand-border-light"
        >
            <div className="max-w-[1400px] mx-auto px-6 md:px-12">
                <div className="grid grid-cols-12 gap-6 mb-16">
                    <div className="col-span-12 md:col-span-4 flex items-center gap-4">
                        <span className="h-px w-10 bg-brand-orange" />
                        <span className="text-xs uppercase tracking-[0.3em] text-brand-orange font-medium">
                            How It Works
                        </span>
                    </div>
                    <h2
                        data-testid="process-headline"
                        className="col-span-12 md:col-span-8 font-serif text-5xl sm:text-6xl md:text-7xl leading-[0.95] tracking-tight"
                    >
                        A four-step
                        <br />
                        <span className="italic">tasting menu.</span>
                    </h2>
                </div>

                <div className="space-y-px bg-brand-border-light">
                    {steps.map((s, i) => (
                        <motion.div
                            key={s.n}
                            initial={{ opacity: 0, x: -30 }}
                            whileInView={{ opacity: 1, x: 0 }}
                            viewport={{ once: true, margin: "-80px" }}
                            transition={{ duration: 0.6, delay: i * 0.08 }}
                            data-testid={`process-step-${s.n}`}
                            className="bg-brand-cream grid grid-cols-12 gap-6 py-10 md:py-14 px-2 md:px-6 group hover:bg-white transition-colors duration-500"
                        >
                            <div className="col-span-12 md:col-span-2">
                                <span className="font-serif italic text-7xl md:text-8xl text-brand-orange leading-none">
                                    {s.n}
                                </span>
                            </div>
                            <div className="col-span-12 md:col-span-4">
                                <h3 className="font-serif text-3xl md:text-5xl text-brand-dark leading-tight">
                                    {s.title}
                                </h3>
                            </div>
                            <div className="col-span-12 md:col-span-6 flex items-center">
                                <p className="text-brand-muted text-lg leading-relaxed max-w-xl">
                                    {s.desc}
                                </p>
                            </div>
                        </motion.div>
                    ))}
                </div>
            </div>
        </section>
    );
}
